/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RuleTemplateIndexDto } from '../models/RuleTemplateIndexDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RuleTemplateService {

    /**
     * Fetch Rule Template index
     * @returns RuleTemplateIndexDto Successfully fetch RuleTemplate index
     * @throws ApiError
     */
    public static getRuleTemplateIndex(): CancelablePromise<RuleTemplateIndexDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rule-templates/index',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
